import React from "react";
import getEstimatedTime from "../../../../../lib/getRecentEstimationTime";

const OrderDetailHead = ({
  statusText,
  restaurant,
  formattedDate,
  order,
  orderUid
}) => {
  const estimatedTime = getEstimatedTime(
    order.orderEarliestDeliveryDeadline,
    order.orderLatestDeliveryDeadline
  );
  return (
    <>
      <div className="white-bg mt-10px d-flex justify-content-between padding-box status visible-xs">
        <div>
          <h4>{statusText}</h4>
          <p>{restaurant.name}</p>
          <p>Ordered: {formattedDate}</p>
          {estimatedTime && order.status !== "ORDER_COMPLETED" && (
            <p className="est-time">Estimated delivery time {estimatedTime}</p>
          )}
        </div>
        {(order.userCanCall && (
          <a href={`tel:${restaurant.contactMobileNumber}`}>
            <icon className="icon icon-phone" />
          </a>
        )) || <noscript />}
      </div>{" "}
      {/* .status */}
      <div className="row status hide-xs">
        <div className="col-sm-4 left">
          <div className="white-bg">
            <div>
              <p>#{orderUid}</p>
              <h4>{statusText}</h4>
            </div>
          </div>
        </div>
        {/* .left */}

        <div className="col-sm-8 right">
          <div className="white-bg">
            <div>
              <p>{restaurant.name}</p>
              <p>Ordered: {formattedDate}</p>
              {estimatedTime && order.status !== "ORDER_COMPLETED" && (
                <p className="est-time">
                  Estimated delivery time {estimatedTime}
                </p>
              )}
            </div>
          </div>
        </div>
        {/* .right */}
      </div>
    </>
  );
};
export default OrderDetailHead;
